export function findKeyConditionById(keyConditionsList, keyConditions, conditionId) {
    keyConditionsList.forEach((condition) => {
        if (condition.key === conditionId) {
            keyConditions.push(condition)
        }
    });
}
